// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__rFxXH","left":"StickyBox_left__3Tmpt","right":"StickyBox_right__33_ff"};